import {
  PmEditPlan,
  PmEditProjectOverview,
  PmProjectBasicDtl,
  PmProjectDesignDoc,
  PmProjectOverview,
  PmProjectPlan,
  PmTeamAssignment,
  TaskHierarchy,
  ViewTaskPlan
} from "@/pages";
import { routes } from "../utils";

export const ProjectOverviewRoutes = () => {
  return {
    path: routes.projectOverview,
    children: [
      {
        path: "",
        element: <PmProjectOverview />,
      },
      {
        path: routes.id + "/" + routes.action,
        children: [
          {
            path: routes.projectPlan,
            children: [
              {
                path: routes.planId + "/" + routes.planAction,
                children: [
                  {
                    path: "",
                    element: <PmEditPlan />,
                  },
                  {
                    path: routes.taskHierarchy,
                    element: <TaskHierarchy />
                  },
                  {
                    path: routes.taskPlan,
                    element: <ViewTaskPlan />
                  }
                ]
              },
            ],
          },
        ],
      },
      {
        path: routes.id + "/" + routes.action,
        element: <PmEditProjectOverview />, // Parent tab container
        children: [
          {
            path: routes.projectInfo,
            element: <PmProjectBasicDtl />,
          },
          {
            path: routes.teamAssignment,
            element: <PmTeamAssignment />,
          },
          {
            path: routes.projectDocDesign,
            element: <PmProjectDesignDoc />,
          },
          {
            path: routes.projectPlan,
            children: [
              {
                path: "",
                element: <PmProjectPlan />,
              },
              {
                path: routes.planId + "/" + routes.planAction,
                element: <PmEditPlan />,
              },
            ],
          },
        ],
      },
    ],
  };
};
